<template>
  <div class="app" :class="{ 'impersonating-active': impersonating }">
    <!-- Landscape overlay for tablets -->
    <div v-if="showLandscapeOverlay" class="landscape-overlay">
      <div class="landscape-overlay__content">
        <div class="landscape-overlay__icon">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8" y="16" width="32" height="48" rx="4" stroke="white" stroke-width="3" fill="none"/>
            <line x1="8" y1="54" x2="40" y2="54" stroke="white" stroke-width="2"/>
            <path d="M48 28 C48 28 56 36 48 44" stroke="white" stroke-width="2.5" stroke-linecap="round" fill="none"/>
            <path d="M44 22 C44 22 60 32 44 46" stroke="white" stroke-width="2.5" stroke-linecap="round" fill="none"/>
          </svg>
        </div>
        <p class="landscape-overlay__text">{{ $t('Пожалуйста, поверните устройство в вертикальное положение') }}</p>
      </div>
    </div>
    <div v-if="impersonating" class="impersonate-banner">
      <span class="impersonate-icon">👤</span>
      <span class="impersonate-text">
        {{ $t('Вы просматриваете аккаунт:') }}
        <strong>{{ impersonating.email }}</strong>
        <span v-if="impersonating.name"> ({{ impersonating.name }})</span>
      </span>
      <button class="impersonate-back" @click="exitImpersonation">
         {{ $t('← Вернуться в Admin') }}
      </button>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      impersonating: null,
      showLandscapeOverlay: false,
    };
  },
  mounted() {
    const raw = localStorage.getItem('impersonating');
    if (raw) {
      try { this.impersonating = JSON.parse(raw); } catch { this.impersonating = null; }
    }
    window.addEventListener('storage', this.onStorage);

    // Landscape lock for tablets
    this.checkOrientation();
    window.addEventListener('resize', this.checkOrientation);
    window.addEventListener('orientationchange', this.checkOrientation);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.onStorage);
    window.removeEventListener('resize', this.checkOrientation);
    window.removeEventListener('orientationchange', this.checkOrientation);
  },
  methods: {
    checkOrientation() {
      const w = window.innerWidth;
      const h = window.innerHeight;
      const isLandscape = w > h;
      // Consider tablet: touch device with larger dimension >= 768px
      const maxDim = Math.max(w, h);
      const isTablet = navigator.maxTouchPoints > 0 && maxDim >= 768;
      this.showLandscapeOverlay = isTablet && isLandscape;
    },
    onStorage(e) {
      if (e.key === 'impersonating') {
        const raw = e.newValue;
        this.impersonating = raw ? JSON.parse(raw) : null;
      }
    },
    exitImpersonation() {
      const adminToken = localStorage.getItem('adminOriginalToken');
      const adminUserRaw = localStorage.getItem('adminOriginalUser');

      if (adminToken) {
        localStorage.setItem('userToken', adminToken);
      }
      if (adminUserRaw) {
        localStorage.setItem('user', adminUserRaw);
      }
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.removeItem('adminOriginalToken');
      localStorage.removeItem('adminOriginalUser');
      localStorage.removeItem('impersonating');

      window.location.href = '/admin/users';
    },
  },
};
</script>

<style lang="scss">
.landscape-overlay {
  position: fixed;
  inset: 0;
  z-index: 999999;
  background: #1a1a2e;
  display: flex;
  align-items: center;
  justify-content: center;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding: 32px;
    text-align: center;
  }

  &__icon {
    animation: rotate-hint 2.5s ease-in-out infinite;
    svg { display: block; }
  }

  &__text {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.5;
    max-width: 280px;
    margin: 0;
  }
}

@keyframes rotate-hint {
  0%, 100% { transform: rotate(0deg); }
  30%       { transform: rotate(-20deg); }
  60%       { transform: rotate(20deg); }
  80%       { transform: rotate(-10deg); }
}


.impersonating-active {
  padding-top: 38px;
}

.impersonate-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 20px;
  background: #1a3a5c;
  color: #fff;
  font-size: 13px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.25);

  .impersonate-icon {
    font-size: 16px;
    flex-shrink: 0;
  }

  .impersonate-text {
    flex: 1;
    strong {
      color: #7ecfff;
    }
  }

  .impersonate-back {
    flex-shrink: 0;
    background: #fff;
    color: #1a3a5c;
    border: none;
    border-radius: 6px;
    padding: 5px 14px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.15s;
    &:hover {
      background: #e8f4ff;
    }
  }
}
</style>
